import { NgModule } from '@angular/core';
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterModule, Routes, RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { VerifyPaymentComponent } from './common/components/verify-payment/verify-payment.component';
import { ShopsComponent } from './partners/shops/shops.component';
import { MerchantHomeComponent } from './partners/merchant-home/merchant-home.component';
import { PartnerSignupComponent } from './partners/partner-signup/partner-signup.component';

@Injectable({ providedIn: 'root' })
export class TemplatePageTitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot) {
    const title = this.buildTitle(routerState);
    if (title !== undefined) {
      this.title.setTitle(`Taly Shop Now Pay Later | ${title}`);
    }
  }
}

const routes: Routes = [
// {
//     path: '**',
//     redirectTo: '',
//     pathMatch: 'full',
//   },
  {
    path: '',
    loadChildren: () =>
      import('./home/home.module').then((m) => m.HomeModule),
  },
  {
    path: ':paymentType/status',
    component : VerifyPaymentComponent,
    title : 'Payment Verification'
  },
  {
    path: ':paymentType/status/:orderid',
    component : VerifyPaymentComponent,
    title : 'Payment Verification'
  },
  {
    path: 'terms-and-conditions',
    loadChildren: () => import('./terms-and-conditions/terms-and-conditions.module').then((m) => m.TermsAndConditionsModule),
  },
  {
    path: 'press',
    loadChildren: () => import('./press-release/press-release.module').then((m) => m.PressReleaseModule),
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./privacy-policy/privacy-policy.module').then((m) => m.PrivacyPolicyModule),
  },
  // {
  //   path: 'partners',
  //   loadChildren: () => import('./partners/partners.module').then((m) => m.PartnersModule),
  // },
  {
      path: 'partners/sign-up',
      component: PartnerSignupComponent,
      data: {
        role: 'PARTNER_SIGNUP',
      },
      title: 'Become a Partner',
    },
  {
    path: 'shops',
    component: ShopsComponent,
     data: {
      role: 'SHOPS',
    },
    title: 'Shops',
  },
  {
      path: 'partners',
      component: MerchantHomeComponent,
      data: {
        role: 'LEARN_MORE',
      },
      title: 'Learn More',
    },
  {
    path: 'secure-checkout',
    loadChildren: () => import('./checkout/checkout.module').then((m) => m.CheckoutModule),
  },
  {
    path: 'faq',
    loadChildren: () => import('./faq/faq.module').then((m) => m.FaqModule),
  },
  {
    path: 'faq-shopper',
    loadChildren: () => import('./faq/faq.module').then((m) => m.FaqModule),
  },
    {
    path: 'faq-partner',
    loadChildren: () => import('./faq/faq.module').then((m) => m.FaqModule),
  },
  {
    path: 'learn-more',
    loadChildren: () => import('./how-it-work/how-it-work.module').then((m) => m.HowItWorkModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { bindToComponentInputs: true })],
  exports: [RouterModule],
  providers: [{ provide: TitleStrategy, useClass: TemplatePageTitleStrategy }],
})
export class AppRoutingModule {}
